import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// La bulle d'une infobulle texte (`TextTooltipDirective`), non interactive : le clic la traverse.
@Component({
  selector: 'app-text-tooltip-bubble',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    {{ text }}
    <span class="tt-arrow"
      [class.tt-arrow--haut]="placement === 'top'"
      [class.tt-arrow--bas]="placement === 'bottom'"
      [style.left.px]="arrowOffset - DEMI_FLECHE"></span>
  `,
  styles: [`
    :host {
      --tt-fond: #1f2937;
      --tt-texte: #fff;
      position: fixed;
      z-index: 50;
      pointer-events: none;
      max-width: min(20rem, calc(100vw - 1rem));
      background: var(--tt-fond);
      color: var(--tt-texte);
      border: var(--tt-bordure, none);
      font-size: 0.75rem;
      line-height: 1.25rem;
      padding: 0.375rem 0.625rem;
      border-radius: 0.375rem;
      box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2), 0 4px 6px -4px rgb(0 0 0 / 0.2);
      animation: tt-apparition 120ms ease-out;
    }

    @media (prefers-reduced-motion: reduce) {
      :host { animation: none; }
    }

    @keyframes tt-apparition {
      from { opacity: 0; transform: scale(0.96); }
      to   { opacity: 1; transform: scale(1); }
    }

    /* Triangle en bordures : boite 0x0, les cotes transparents font la largeur. */
    .tt-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }

    /* Bulle au-dessus de l'hote : la pointe descend. */
    .tt-arrow--haut {
      top: 100%;
      border-top: 6px solid var(--tt-fond);
    }

    /* Bulle au-dessous : la pointe monte. */
    .tt-arrow--bas {
      bottom: 100%;
      border-bottom: 6px solid var(--tt-fond);
    }
  `]
})
export class TextTooltipBubbleComponent {
  /** Texte deja traduit. */
  @Input() text = '';

  /** Cote de pose de la bulle : oriente la pointe. */
  @Input() placement: 'top' | 'bottom' = 'top';

  // Abscisse de la pointe depuis le bord gauche, bornee au cadre par la directive.
  @Input() arrowOffset = 0;

  /** Demi-largeur du triangle, egale aux bordures transparentes ci-dessus. */
  readonly DEMI_FLECHE = 6;
}
